import Announcement from "@mapmycustomers/shared/types/announcements/Announcement";

import AnnouncementCta from "@app/types/AnnouncementCta";

// No label or no destination means no CTA; the external URL wins if both are set.
const getAnnouncementCta = ({
  ctaExternalUrl,
  ctaLabel,
  ctaPageId,
}: Announcement): AnnouncementCta | undefined => {
  if (!ctaLabel) {
    return undefined;
  }
  if (ctaExternalUrl) {
    return { externalUrl: ctaExternalUrl, kind: "external", label: ctaLabel };
  }
  if (ctaPageId) {
    return { kind: "page", label: ctaLabel, pageId: ctaPageId };
  }
  return undefined;
};

export default getAnnouncementCta;
